module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"it":{"area":"Luogo","duration":"Durata","months":"mesi"},"en":{"duration":"Duration","months":"months","area":"Location"}}')
  delete Component.options._Ctor
}
